import get from 'lodash/get';

import { VALIDATION_ERRORS } from '../../constants/strings';
import requiredValidator from './requiredValidator';
import phoneValidator from './phoneValidator';
import emailValidator from './emailValidator';
import DOBValidator from './DOBValidator';
import aliasNameFormatValidator from './aliasNameFormatValidator';
import maxLengthValidator from './maxLengthValidator';
import minLengthValidator from './minLengthValidator';
import postalCodeValidator from './postalCodeValidator';
import SSNValidator from './SSNValidator';
import workingHoursValidator from './workingHoursValidator';
import usernameValidator from './usernameValidator';

export const RULES = {
  REQUIRED: 'REQUIRED',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  DOB: 'DOB',
  ALIAS_FORMAT: 'ALIAS_FORMAT',
  USERNAME_FORMAT: 'USERNAME_FORMAT',
  MAX_LENGTH: 'MAX_LENGTH',
  MIN_LENGTH: 'MIN_LENGTH',
  POSTAL_CODE: 'POSTAL_CODE',
  SSN: 'SSN',
  WORKING_HOURS: 'WORKING_HOURS',
};

const validators = {
  [RULES.REQUIRED]: requiredValidator,
  [RULES.PHONE]: phoneValidator,
  [RULES.EMAIL]: emailValidator,
  [RULES.DOB]: DOBValidator,
  [RULES.ALIAS_FORMAT]: aliasNameFormatValidator,
  [RULES.USERNAME_FORMAT]: usernameValidator,
  [RULES.MAX_LENGTH]: maxLengthValidator,
  [RULES.MIN_LENGTH]: minLengthValidator,
  [RULES.POSTAL_CODE]: postalCodeValidator,
  [RULES.SSN]: SSNValidator,
  [RULES.WORKING_HOURS]: workingHoursValidator,
};

export function validateWithRule(ruleName, rule, value, formatMessage) {
  const { message } = rule;
  return validators[ruleName](value, rule)
    ? null
    : formatMessage(get(VALIDATION_ERRORS, message));
}



// WEBPACK FOOTER //
// ./src/utils/validations/index.js